import { IApi } from '@/setup/api-client'
import { useApiMutation } from '@/utils/api/api-mutation'
import { useApiToolbox } from '@/utils/api/use-api-toolbox'
import type {
    IUpdateOrganizationRequestBody,
    IUpdateOrganizationResponseData,
} from 'api/dist/routes/organization/[organization_id]/index.js'
import { GetDatabaseOrganizationQuery } from '@/api/organization/get-database-organization'

interface IUpdateOrganizationArgs {
    organizationId: string
    body: IUpdateOrganizationRequestBody
}

export class UpdateOrganizationMutation {
    static async call(api: IApi, args: IUpdateOrganizationArgs) {
        return api
            .patch<IUpdateOrganizationResponseData, IUpdateOrganizationRequestBody>(
                `/organization/${args.organizationId}`,
                args.body
            )
            .then((res) => res.data)
    }
}

export function useUpdateOrganizationMutation() {
    const { api, apiParams, qc } = useApiToolbox()

    return useApiMutation<IUpdateOrganizationResponseData, IUpdateOrganizationRequestBody>({
        mutationFn: (body) =>
            UpdateOrganizationMutation.call(api, {
                organizationId: apiParams.organizationId,
                body,
            }),
        onSuccess: () => {
            qc.invalidateQueries({
                queryKey: GetDatabaseOrganizationQuery.getKey({ organizationId: apiParams.organizationId }),
            })
        },
    })
}
